const FAVICON_SIZE = 64;
const FAVICON_COLORS = { up: "#22c55e", degraded: "#fb923c", critical: "#ef4444", down: "#ef4444", unknown: "#9ca3af" };

// public/A_bgless.png is 1145x1788 but the visible mark only spans rows
// ~470-1425 — the rest is transparent padding. Crop to that bounding box first
// so the favicon isn't dominated by empty space (looks tiny otherwise).
const LOGO_CROP = { sx: 0, sy: 470, sw: 1120, sh: 956 };

// Loaded once and reused so every status change just re-tints the same image.
let faviconLogoPromise = null;
function loadFaviconLogo() {
  if (!faviconLogoPromise) {
    faviconLogoPromise = new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = `${process.env.PUBLIC_URL || ""}/A_bgless.png`;
    });
  }
  return faviconLogoPromise;
}

export async function setStatusFavicon(status) {
  let logo;
  try {
    logo = await loadFaviconLogo();
  } catch {
    return; // logo asset failed to load; leave favicon untouched
  }
  const canvas = document.createElement("canvas");
  canvas.width = FAVICON_SIZE;
  canvas.height = FAVICON_SIZE;
  const ctx = canvas.getContext("2d");
  // "Contain" fit (with minimal margin) within the square favicon.
  const scale = Math.min(canvas.width / LOGO_CROP.sw, canvas.height / LOGO_CROP.sh) * 0.95;
  const w = LOGO_CROP.sw * scale;
  const h = LOGO_CROP.sh * scale;
  ctx.drawImage(
    logo,
    LOGO_CROP.sx, LOGO_CROP.sy, LOGO_CROP.sw, LOGO_CROP.sh,
    (canvas.width - w) / 2, (canvas.height - h) / 2, w, h
  );
  // Recolor just the opaque "A" pixels, keeping the transparent background.
  ctx.globalCompositeOperation = "source-in";
  ctx.fillStyle = FAVICON_COLORS[status] || FAVICON_COLORS.unknown;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  applyFaviconHref(canvas.toDataURL());
}

// Status-colored favicon is specific to the admin area — restore the plain
// brand icon as soon as it's left so other screens never inherit a stale color.
export function resetFavicon() {
  applyFaviconHref(`${process.env.PUBLIC_URL || ""}/A_bgless.png`);
}

// Some browsers (notably Chrome) don't reliably repaint the tab icon when you
// just mutate `.href` on an already-attached <link rel="icon">. Removing the
// old link and inserting a brand new one forces a real refresh every time.
function applyFaviconHref(href) {
  document.querySelectorAll("link[rel~='icon']").forEach((el) => el.remove());
  const link = document.createElement("link");
  link.rel = "icon";
  link.href = href;
  document.head.appendChild(link);
}
